// i18n.ts - old name

import { defineStore } from 'pinia';
import { axios } from '@/plugins/http-axios';
import { useErrorStore } from '@/pinia/helpers/error';
import { useUriStore } from '@/pinia/general/uri';

export const useVocStore = defineStore('voc', {
  state: () => ({
    vocState: {} as Record<string, string>,
  }),
  actions: {
    setVoc(data: Record<string, string>) {
      this.vocState = data;
    },
    async getVoc() {
      if (Object.keys(this.vocState).length) return;
      const errorStore = useErrorStore();
      const uriStore = useUriStore();

      const res = await axios.get<Record<string, string>>(uriStore.i18n).catch((e) => {
        e.uri = uriStore.i18n;
        errorStore.setError(e);
      });
      if (!res) return;
      this.setVoc(res.data);
    },

  },
  getters: {
    voc: (state) => state.vocState,
  },
});
